module.exports = __webpack_public_path__ + "img/logo-w.626e60a8.png";